<template>
  <DefaultSidebarLayout :title="$t('network.trending')">
    <template slot="sidebar">
      <div class="row pt-lg-2 pt-sm-0">
        <h3 class="fw-bold text-primary d-none d-sm-block">{{ $t('network.trending') }}</h3>
        <div class="col-md-12 py-2">
          <ul style="list-style-type: none;" class="p-0">
            <li v-for="(network, index) in trendingNetworks" :key="index" class="py-2">
              <div class="row g-0">
                <div class="col-2 col-lg-3 col-xl-2 custom-margin">
                  <avatar
                    :username="network.network_name"
                    :src="network.network_image"
                    :size="50"
                    color="white"
                    :class="[index % 2 == 0 ? 'bg-gradient-primary-dark' : 'bg-gradient-primary-light']"
                    class="img rounded"
                  ></avatar>
                </div>
                <div class="col-10 col-lg-9 col-xl-9 ps-4 ps-lg-3 ps-xl-3 ps-xxl-3">
                  <router-link :to="'/networks/' + network.network_slug">
                    {{ network.network_name }}
                  </router-link>
                  <br />
                  <small class="text-muted">
                    {{ network.num_total_hits }}
                    <span v-if="network.num_total_hits > 1">{{ $t('Index.users').toLowerCase() }}</span>
                    <span v-else>{{ $t('network.member.user').toLowerCase() }}</span>
                    {{ $t('Networks.accessed-in-30-days') }}
                  </small>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>

    <div class="row pb-4">
      <div>
        <div class="d-block d-sm-none" style="margin-top: 3rem;"></div>
        <div class="col-md-6 offset-md-3 col-sm-12 d-lg-none d-xl-none py-2">
          <div class="dropdown">
            <button id="jump_to_section" data-test="jump_to_section" type="button" data-bs-toggle="dropdown" aria-expanded="false" class="btn dropdown-toggle" style="border-color: #dfdfeb; width: 100%;">
              {{ $t('select-to-jump-to-a-section') }} <i class="fas fa-angle-down"></i>
            </button>
            <ul class="dropdown-menu" style="padding: 10px; cursor: pointer; width: -webkit-fill-available; line-height: 2rem;">
              <li v-if="myManagedNetworks.length > 0" @click="scrollTo('managed_networks')">{{ $t('network.myManagedNetworks') }}</li>
              <li v-if="myNetworks.length > 0" @click="scrollTo('my_networks')">{{ $t('network.myNetworks') }}</li>
              <li v-if="discoverNetworks.length > 0" @click="scrollTo('discover_networks')">{{ $t('network.discoverNetworks') }} {{ $t('network.networks').toLowerCase() }}</li>
            </ul>
          </div>
        </div>
        <h2 ref="textData" class="fw-bold pt-4 text-primary mb-0 d-none d-lg-block">{{ $t('network.networks') }}</h2>
      </div>
    </div>

    <div class="row px-1" style="margin-top: -1rem">
      <div class="d-lg-none d-xl-none"></div>
      <NetworkList v-if="myManagedNetworks.length > 0" id="managed_networks" :title="$t('network.myManagedNetworks')" :networks="myManagedNetworks" :notifications=true />
      <NetworkList v-if="myNetworks.length > 0" id="my_networks" :title="$t('network.myNetworks')" :networks="myNetworks" :notifications=true />
      <NetworkList v-if="discoverNetworks.length > 0" id="discover_networks" :title="$t('network.discoverNetworks')" :networks="discoverNetworks" />
    </div>
    <b-modal v-if="$auth.auth && (userData.progress < 80 || !userData.are_requirements_complete)" v-model="showUserDataModal" hide-footer hide-header size="lg" class="p-0">
      <div class="card card-hover shadow-lg p-0" style="margin: -21px;">
        <div class="card-body p-0">
          <div class="col-12 d-flex justify-content-between">
            <div class="col-3 border-end py-2" :style="{ background: userData.progress > 25 ? '#005F9A' : '#979A9C' }" style="border-top-left-radius: 0.75rem !important;"></div>
            <div class="col-3 border-end py-2" :style="{ background: userData.progress > 50 ? '#005F9A' : '#979A9C' }"></div>
            <div class="col-3 border-end py-2" :style="{ background: userData.progress > 75 ? '#005F9A' : '#979A9C' }"></div>
            <div class="col-3 border-end py-2" :style="{ background: userData.progress > 99 ? '#005F9A' : '#979A9C' }" style="border-top-right-radius: 0.75rem !important;"></div>
          </div>
          <div class="card-title p-3 mb-0">
            <div class="m-2 fs-5">
              <span class="fs-3">Hello {{ userData.general.first_name }}!</span>
            </div>
          </div>
          <div class="p-4 d-flex justify-content-between" style="background-color: #E5F6F9;">
            <div class="avatar" style="width: 4.5rem !important; height: 4rem !important;">
              <img :src="userData.general.profile_image_url ? userData.general.profile_image_url : '/img/user.png'"
              class="avatar-img rounded-circle" />
            </div>
            <span class="mx-4 mt-2 fs-5">
              To help us get to know you better, please proceed with the profile completion process.
            </span>
          </div>
        </div>
        <div class="card-footer border-0 text-start py-4">
          <router-link :to="{ path: '/profile/edit', query: { tab: 'workinfo' } }">
            <button class="btn btn-primary me-4" style="height: 49px; padding: 0.425rem 1.7rem !important;">Complete profile</button>
          </router-link>
          <button class="btn btn-outline-primary" style="height: 49px; border: 2px solid; padding: 0.425rem 1.7rem !important;" @click="skipForNow">
            Skip for now
          </button>
        </div>
      </div>
    </b-modal>
  </DefaultSidebarLayout>
</template>
<script>
import DefaultSidebarLayout from './layouts/default-sidebar/';
import NetworkList from '@/components/commons/Networks/NetworkList.vue';
import Avatar from 'vue-avatar';
import { mapState } from 'vuex';

export default {
  components: {
    DefaultSidebarLayout,
    NetworkList,
    Avatar,
  },
  data() {
    return {
      showUserDataModal: false,
    };
  },
  computed: {
    ...mapState('network', ['myManagedNetworks', 'myNetworks', 'discoverNetworks', 'trendingNetworks', 'userData']),
    shouldShowModal() {
      const skipUntil = localStorage.getItem('userDataModalSkipUntil');
      if (skipUntil) {
        const now = new Date();
        return now.getTime() > parseInt(skipUntil, 10);
      }
      return true;
    },
  },
  watch: {
    shouldShowModal(newVal) {
      this.showUserDataModal = newVal;
    }
  },
  mounted() {
    this.$store.dispatch('network/loadNetworks', { search: '' });
    this.$store.dispatch('network/loadTrendingNetworks', { search: '' });
    if (this.$auth.auth) {
      this.$store.dispatch('network/loadUserData', { search: '' });
    }
    this.showUserDataModal = this.shouldShowModal;
  },
  methods: {
    scrollTo(id) {
      var element = document.getElementById(id);
      var headerOffset = 80;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    },
    skipForNow() {
      const now = new Date();
      localStorage.setItem('userDataModalSkipUntil', now.getTime() + 5 * 24 * 60 * 60 * 1000); // 5 days in milliseconds
      this.showUserDataModal = false;
    },
  },
  randomColorGradient() {
    // setting random background gradients for trending networks
    var colors = ['gradient-1', 'gradient-2', 'gradient-3', 'gradient-4', 'gradient-5'];
    return colors[Math.floor(Math.random() * colors.length)];
  },
};
</script>
<style scoped>
@media (min-width: 2000px){
  .custom-margin {
    margin-right: -30px !important;
  }
}
</style>
